/* eslint-disable @typescript-eslint/naming-convention */

import {
    AvcId,
    LegalId,
    LmFormId,
} from '../../enums/elementId';

/**
 * Type of Overlay contents
 */
export enum OverlayContent {
    AVC = AvcId.AVC_FORM,
    AVC_RESULT = AvcId.AVC_RESULT,
    CAPTCHA = AvcId.AVC_CAPTCHA,
    LM_FORM = LmFormId.WRAPPER,
    LEGAL = LegalId.WRAPPER,
}

/**
 * Type of overlay actions
 */
export enum OverlayAction {
    INIT = 'CABLE/OVERLAY/INIT',
    START_LOADING = 'CABLE/OVERLAY/START_LOADING',
    STOP_LOADING = 'CABLE/OVERLAY/STOP_LOADING',
    LOADED = 'CABLE/OVERLAY/LOADED',
    SET_OVERLAY_VISIBILITY = 'CABLE/OVERLAY/SET_OVERLAY_VISIBILITY',
    SET_OVERLAY_CONTENT = 'CABLE/OVERLAY/SET_OVERLAY_CONTENT',
    CANCEL_AVAILABILITY_CHECK = 'CABLE/OVERLAY/CANCEL_AVAILABILITY_CHECK',
    PREVENT_CANCEL = 'CABLE/OVERLAY/PREVENT_CANCEL',
}
